import React
//,
 //{ 
  //useEffect, 
 // useMemo, 
 // useRef } 
  from "react";


import { getFile } from "../crud/auth.crud";

export default class S3Image extends React.Component {

 
constructor(props)
{
  super(props);

  console.log("prog====",props);
  
  this.state = {
      id:props.id,
      originalFileKey:props.originalFileKey,
      downloadUrl:'media/misc/loading.gif',
    };

}
  
componentDidMount()
  {
     if(this.state.id != "")
     {
      getFile(this.state.id,this.state.originalFileKey).then(response => response.data)
        .then((data) => {
          this.setState({downloadUrl: data.downloadUrl})
        })
         .catch(error => {
          this.setState({downloadUrl: 'media/misc/loading.gif'})
          });
      }
  }

  render()
  {
    //console.log("open status=="+this.state.downloadUrl);
    return (
      <img src={this.state.downloadUrl} alt="pic"/>
    );
  }
}
